// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Case__Wrapper_lgKZ7","Image":"Case__Image_QxKgV","Inner":"Case__Inner_14gS4","Top":"Case__Top_2gYle","Tag":"Case__Tag_1fQut","Description":"Case__Description_2bJsf"};